export const modernSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '34px',
    height: '34px',
    borderRadius: '999px',

    border: state.isFocused
      ? '1px solid #2563eb'
      : '1px solid #e5e7eb',

    boxShadow: 'none',

    backgroundColor: '#fff',

    '&:hover': {
      borderColor: '#2563eb',
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: '34px',
    padding: '0 12px',
  }),

  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),

  placeholder: (provided) => ({
    ...provided,
    color: '#6b7280',
    fontSize: '0.8rem',
    margin: 0,
  }),

  singleValue: (provided) => ({
    ...provided,
    fontSize: '0.8rem',
    fontWeight: 600,
    color: '#374151',
    margin: 0,
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '4px',
  }),

  clearIndicator: (provided) => ({
    ...provided,
    padding: '4px',
  }),

  menu: (provided) => ({
    ...provided,
    borderRadius: '14px',
    overflow: 'hidden',
    boxShadow: '0 10px 25px rgba(0,0,0,.12)',
    zIndex: 9999,
  }),

  menuList: (provided) => ({
    ...provided,
    padding: '4px',
  }),

  option: (provided, state) => ({
    ...provided,
    borderRadius: '8px',
    padding: '8px 12px',
    fontSize: '0.85rem',

    backgroundColor: state.isSelected
      ? '#2563eb'
      : state.isFocused
      ? '#eff6ff'
      : '#fff',

    color: state.isSelected ? '#fff' : '#111827',
  }),
};